import React, { FC } from "react";
import { Field, FormRenderProps, useFormState } from "react-final-form";
import { makeStyles } from "@material-ui/core";
import Autocomplete from "../../../../../components/Autocomplete";
import { applyAsStep1 } from "./config";
import { IApplicationFrontEndModel } from "../../../types";
import { useAuth } from "../../../../auth/hooks/useAuth";
import { UserRole } from "../../../../user/enums/UserRole";

const useStyles = makeStyles(() => ({
  mainContainer: {
    width: "100%",
    height: 400,
    "& > div": {
      marginTop: 20,
    },
  },
}));

const ApplyApplicationForm: FC<FormRenderProps> = ({ handleSubmit }) => {
  const classes = useStyles();

  const formData = useFormState();
  const { user } = useAuth();

  const isStudent = user.role === UserRole.Student;
  const values = formData.values as IApplicationFrontEndModel;
  const students = values.injectedData.students;
  const branches = values.injectedData.program.branches;
  const intakes = values.injectedData.program.intakes;
  const stepName = applyAsStep1.stepName;

  return (
    <form noValidate onSubmit={handleSubmit}>
      <div className={classes.mainContainer}>
        {!isStudent && (
          <Field
            fullWidth
            required
            name={`${stepName}.student`}
            label="Student"
            placeholder="Please select a student"
            options={students}
            component={Autocomplete}
          />
        )}
        <Field
          fullWidth
          required
          name={`${stepName}.branch`}
          label="Branch"
          placeholder="Please select a branch"
          options={branches}
          component={Autocomplete}
        />
        {intakes && (
          <Field
            fullWidth
            required
            name={`${stepName}.intake`}
            label="Intake"
            placeholder="Please select an intake"
            options={intakes}
            component={Autocomplete}
          />
        )}
      </div>
    </form>
  );
};

export default ApplyApplicationForm;
